import { useCollapsed } from './collapse.js';
import { CardChevron } from './icons.js';

import type { ReactNode } from 'react';

interface CardProps {
  /** Page-scoped key for the open or closed state, e.g. `dash:sev`. */
  stateKey: string;
  title: string;
  /** Dashboard cards use an `h3`; detail sections use the `.bk` label. */
  titleStyle?: 'h3' | 'bk';
  hint?: string | null;
  className?: string;
  /** Wrap the body in `.card-b` (every card but the BOM context). */
  padded?: boolean;
  children: ReactNode;
}

/** Prototype `card()` and `secBtn()`: a collapsible card with a chevron header. */
export function Card({
  stateKey,
  title,
  titleStyle = 'h3',
  hint,
  className,
  padded = true,
  children,
}: CardProps) {
  const [open, toggle] = useCollapsed(stateKey);
  return (
    <section className={`card${className ? ` ${className}` : ''}`}>
      <button type="button" className="card-h ffh" aria-expanded={open} onClick={toggle}>
        {titleStyle === 'h3' ? (
          // An h3 for the prototype's styles; level 2 under the page's h1 for screen readers.
          <h3 aria-level={2}>{title}</h3>
        ) : (
          <span className="bk">{title}</span>
        )}
        {hint ? <span className="hint">{hint}</span> : null}
        <CardChevron open={open} />
      </button>
      {open ? padded ? <div className="card-b">{children}</div> : children : null}
    </section>
  );
}
